import { useCallback, useState, useEffect } from "react";
import { useUnit } from "effector-react";
import {
  $userProfile,
  $userProfileLoading,
  $userProfileError,
  fetchUserProfile,
} from "@features/settings/store";

export const SettingsTabsViewModel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const userProfile = useUnit($userProfile);
  const loading = useUnit($userProfileLoading);
  const error = useUnit($userProfileError);
  const fetchProfile = useUnit(fetchUserProfile);

  useEffect(() => {
    // Fetch profile only if it hasn't been fetched yet
    if (!userProfile && !loading && !error) {
      fetchProfile();
    }
  }, [userProfile, loading, error, fetchProfile]);

  const onTabChange = useCallback((index: number) => setActiveIndex(index), []);

  return {
    activeIndex,
    onTabChange,
    userProfile,
    loading,
    error,
    refetchProfile: fetchProfile,
  };
};
